import { Task, TaskType } from '../../../../../clients/quipli-service/job-tasks/job-tasks';

/**
 * Checks if all tasks for a given unit are complete (regardless of success or failure).
 * @param tasks - The tasks.
 * @param unitId - The unit id.
 * @returns True if all tasks are complete, false otherwise.
 */
export const areUnitTasksComplete = (tasks: Task[], unitId: number): boolean => {
  const hoursTask = tasks.find((t) => t.metadata?.productUnitId === unitId && t.type === TaskType.MachineHours);
  const checklistTask = tasks.find(
    (t) => t.metadata?.productUnitId === unitId && t.type === TaskType.InspectionChecklist,
  );
  const mediaTask = tasks.find((t) => t.metadata?.productUnitId === unitId && t.type === TaskType.MediaUpload);

  const hoursComplete = hoursTask ? hoursTask.status === 'Complete' : true;
  const checklistComplete = checklistTask ? checklistTask.status === 'Complete' : true;
  const mediaComplete = mediaTask ? mediaTask.status === 'Complete' : true;

  return hoursComplete && checklistComplete && mediaComplete;
};

export const areUnitTasksSuccessful = (tasks: Task[], unitId: number): boolean => {
  return (
    tasks.find(
      (t) =>
        t.type === TaskType.InspectionChecklist &&
        t.metadata?.productUnitId === unitId &&
        t.metadata.checklist.some((item: any) => item.value === false),
    ) === undefined
  );
};
